import { render } from "./CaricaFoto.vue?vue&type=template&id=0386edb4&scoped=true"
import script from "./CaricaFoto.vue?vue&type=script&lang=js"
export * from "./CaricaFoto.vue?vue&type=script&lang=js"

import "./CaricaFoto.vue?vue&type=style&index=0&id=0386edb4&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0386edb4"]])

export default __exports__